import gql from 'graphql-tag';

export const GET_CONTRACT_TEMPLATE = gql`
  query ContractTemplate {
    contractTemplate
  }
`;
